import PropTypes from "prop-types";
import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import { useSettings } from "../../hooks/useSettings";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";

const ReturnPolicy = ({ location }) => {
    const { pathname } = location;
    const { siteName } = useSettings();

    return (
        <Fragment>
            <MetaTags>
                <title>Return Policy | {siteName}</title>
                <meta
                    name="description"
                    content={`Return Policy ${siteName}`}
                />
            </MetaTags>
            <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>Home</BreadcrumbsItem>
            <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>
                Retrun Policy
            </BreadcrumbsItem>
            <LayoutOne headerTop="visible">
                {/* breadcrumb */}
                <Breadcrumb />
                <div className="blog-area pt-10 pb-100">
                    <div className="container">
                        <div className="row flex-row-reverse">
                            <div className="col-lg-12">
                                <div className="blog-details-wrapper ml-20">
                                    <div className="blog-details-top">
                                        <div className="w-100 text-center pt-10">
                                            <h2>Retrun Policy</h2>
                                        </div>
                                        <div className="blog-details-content">
                                            <h3 className="pt-20">Overview</h3>
                                            <p>
                                                At {siteName}, we strive to provide the best experience for our customers. Please carefully review our return policy below:
                                            </p>
                                            <h3 className="pt-20">Eligibility for Returns</h3>
                                            <ul className="ml-5" style={{ listStyleType: 'square' }}>
                                                <li className="mb-2">We currently ship to all GCC countries and India</li>
                                            </ul>
                                            <h3 className="pt-30">Processing Time</h3>
                                            <p>
                                                Orders are typically processed and shipped within 24 hours of confirmation (excluding weekends and public holidays).
                                            </p>
                                            <h3 className="pt-30">Delivery Time</h3>
                                            <ul className="ml-5" style={{ listStyleType: 'square' }}>
                                                <li className="mb-2">Major Cities: Delivery within 2-5 working days.</li>
                                                <li className="mb-2">Rural Areas: Delivery within 6-8 working days.</li>
                                            </ul>
                                            <h3 className="pt-30">Shipping Charges</h3>
                                            <ul className="ml-5" style={{ listStyleType: 'square' }}>
                                                <li className="mb-2">Shipping charges may vary depending on your location and the size of your order. The exact amount will be calculated and displayed at checkout.</li>
                                            </ul>
                                            <h3 className="pt-30">Order Tracking</h3>
                                            <ul className="ml-5" style={{ listStyleType: 'square' }}>
                                                <li className="mb-2">Once your order is shipped, you will receive a tracking number via email or SMS to monitor its progress.</li>
                                            </ul>
                                            <h3 className="pt-30">Delivery Delays</h3>
                                            <ul className="ml-5" style={{ listStyleType: 'square' }}>
                                                <li className="mb-2">While we strive to ensure timely delivery, unforeseen circumstances such as weather conditions, customs clearance, or public holidays may cause delays. We appreciate your understanding in such cases.</li>
                                            </ul>

                                            <h3 className="pt-30">Important Notes</h3>
                                            <ul className="ml-5" style={{ listStyleType: 'square' }}>
                                                <li className="mb-2">Please ensure that the delivery address and contact information provided at checkout are accurate to avoid delays.</li>
                                                <li className="mb-2">For remote or hard-to-reach areas, additional time may be required for delivery.</li>
                                            </ul>
                                            <p>For any inquiries or assistance regarding shipping, please contact us at support@lauraveils.com.</p>
                                            <p className="pt-10">We look forward to serving you!</p>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </LayoutOne>
        </Fragment>
    );
};

ReturnPolicy.propTypes = {
    location: PropTypes.object
};

export default ReturnPolicy;
